export default "<button [disabled]=\"disabled\" [class]=\"color\" (click)=\"onClick()\">\n  <span class=\"button-label\">{{label}}</span>\n</button>\n";